// The patient record: header, the four tabs, the شرح حال sections, the timeline.
export const record = {
  // ── the patient record ───────────────────────────────────────────────
  'record.notFound.title': 'This patient was not found',
  'record.notFound.body': 'It may have been deleted. Go back to your list.',
  'record.notFound.action': 'Back to patients',
  'record.tabs.overview': 'Overview',
  'record.tabs.history': 'History',
  'record.tabs.visits': 'Visits',
  'record.tabs.timeline': 'Timeline',
  'record.header.visits': 'Visits ×{{count}}',
  'record.header.lastVisit': 'Last visit {{date}}',
  'record.header.archived': 'Archived',
  'record.header.archivedHint': 'Unarchive the patient to start a visit.',
  'record.actions.startVisit': 'Start visit',
  'record.actions.continueVisit': 'Continue open visit',
  'record.actions.chat': 'Chat with the assistant',
  'record.actions.edit': 'Edit patient',
  'record.actions.archive': 'Archive',
  'record.actions.unarchive': 'Unarchive',
  'record.actions.delete': 'Delete',
  'record.saved': 'Saved.',
  'record.startVisit.title': 'Start a visit',
  'record.startVisit.reason': 'Reason for the visit',
  'record.startVisit.reasonHelper': 'Pre-filled from the chief complaint; change it if this visit is about something else.',
  'record.startVisit.submit': 'Start visit',
  'record.startVisit.alreadyOpen': 'A visit was already open — continuing it.',
  'record.overview.details': 'Details',
  'record.overview.allergies': 'Allergy alert',
  'record.overview.problems': 'Active problems',
  'record.overview.meds': 'Current medications',
  'record.overview.pendingOrders': 'Pending orders',
  'record.overview.lastVisit': 'Last visit',
  'record.overview.recentChats': 'Recent conversations',
  'record.overview.noProblems': 'No active problems recorded.',
  'record.overview.noMeds': 'No current medications.',
  'record.overview.noOrders': 'No pending orders.',
  'record.overview.noVisits': 'No visits yet.',
  'record.overview.noChats': 'No conversations yet.',
  'record.overview.openVisit': 'Open visit',
  'record.overview.fromHistory': 'from history',
  'record.overview.fromVisit': 'visit {{n}}',
  'record.visits.empty.title': 'No visits yet',
  'record.visits.empty.body': 'Start a visit to document a SOAP note, diagnoses, a prescription and orders.',
  'record.visits.columns.visit': 'Visit',
  'record.visits.columns.date': 'Date',
  'record.visits.columns.reason': 'Reason',
  'record.visits.columns.status': 'Status',
  'record.visits.columns.counts': 'Dx · Rx · Orders',
  'record.visits.columns.summary': 'Summary',
  'record.visits.openLabel': 'Open visit {{n}}',
  'record.timeline.empty.title': 'Nothing on the timeline yet',
  'record.timeline.empty.body': 'Visits, findings, diagnoses and orders will appear here in order.',
  'record.timeline.outside': 'Outside any visit',
  'record.timeline.filter': 'Filter by type',
  'record.history.hint': 'Write the seven sections — this is what the assistant reads.',
  'record.history.dictate': 'Dictate',
  'record.history.visitChip': 'Visit {{n}}',

  // ── timeline event types (BFF-derived) ───────────────────────────────
  'timeline.type.encounter_start': 'Visit started',
  'timeline.type.encounter_end': 'Visit closed',
  'timeline.type.entry': 'History entry',
  'timeline.type.diagnosis': 'Diagnosis',
  'timeline.type.rx': 'Prescription',
  'timeline.type.order': 'Order',
  'timeline.type.order_result': 'Result',
  'timeline.type.thread': 'Conversation',

  // ── شرح حال — the seven sections ─────────────────────────────────────
  'history.sections.chiefComplaint': 'Chief complaint',
  'history.sections.hpi': 'History of present illness',
  'history.sections.pmh': 'Past medical history',
  'history.sections.medications': 'Current medications',
  'history.sections.allergies': 'Allergies',
  'history.sections.vitals': 'Vital signs',
  'history.sections.labs': 'Labs',
  'history.empty.title': 'Nothing written here yet',
  'history.empty.body': 'Write this section out — it is what the assistant reads.',
  'history.add': 'Add',
  'history.entry.label': 'Heading',
  'history.entry.labelPlaceholder': 'Blood test, 1405/05/12',
  'history.entry.body': 'What you want to record',
  'history.entry.bodyPlaceholder': 'Write it the way you would say it out loud.',
  'history.entry.recordedAt': 'When it happened in the case',
  'history.entry.recordedAtHelper': 'Optional, and usually left empty.',
  'history.entry.sourceLabel': 'Written by',
  'history.entry.source.manual': 'You',
  'history.entry.source.voice': 'You, from a voice draft',
  'history.entry.source.ai': 'You, from an AI suggestion',
  'history.entry.needsContent': 'Write something, or fill in at least one row.',
  'history.delete.title': 'Delete this entry?',
  'history.delete.body': 'Only this entry goes. The rest of the record stays.',
  'history.saved': 'The history was saved.',
  'history.deleted': 'The entry was deleted.',
  'history.structured.title': 'Structured values',
  'history.structured.helper': 'Optional. The written text above is what carries the case.',
  'history.vitals.bp': 'Blood pressure',
  'history.vitals.hr': 'Heart rate',
  'history.vitals.rr': 'Respiratory rate',
  'history.vitals.temp': 'Temperature',
  'history.vitals.spo2': 'SpO₂',
  'history.units.bpm': 'bpm',
  'history.units.perMin': '/min',
  'history.units.celsius': '°C',
  'history.units.percent': '%',
  'history.labs.name': 'Test',
  'history.labs.value': 'Value',
  'history.labs.unit': 'Unit',
  'history.labs.ref': 'Reference',
  'history.labs.addRow': 'Add a row',
  'history.labs.removeRow': 'Remove this row',
};

export default record;
